<div class="mb-2">
  <app-agregar-dias-libres (onDebounce)="TraerDatos($event)"></app-agregar-dias-libres>
</div>

<div class="row pr-3 mb-2">
  <div class="col-2">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput [(ngModel)]="textSearch" (keyup)="applyFilter()" />
      <button mat-icon-button matSuffix (click)="quitarFiltro()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="col-2 d-flex align-items-center">
    <div class="col-12">
        <div class="p-inputgroup">
            <button type="button" (click)="CambiarMes('LEFT')" pButton pRipple
                icon="pi pi-angle-left" styleClass="p-button"></button>
            <p-calendar [(ngModel)]="periodo" view="month" dateFormat="mm/yy" styleClass="w-100"
                (onClose)="FiltrarDatos()" [readonlyInput]="true" appendTo="body"></p-calendar>
            <button type="button" (click)="CambiarMes('RIGHT')" pButton pRipple
                icon="pi pi-angle-right" styleClass="p-button"></button>
        </div>
    </div>
</div>
</div>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">
    <!-- Columna RUT: solo si contexto es 'completo' -->
    <ng-container *ngIf="contexto === 'completo'" matColumnDef="rut">
      <th mat-header-cell *matHeaderCellDef style="width: 8%" mat-sort-header> RUT </th>
      <td mat-cell *matCellDef="let element" class="font-semibold"> {{ element.rut | formatoRut }} </td>
    </ng-container>

    <!-- Columna Trabajador: solo si contexto es 'completo' -->
    <ng-container *ngIf="contexto === 'completo'" matColumnDef="trabajador">
      <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header> TRABAJADOR </th>
      <td mat-cell *matCellDef="let element" class="font-semibold"> {{ element.trabajador | titlecase }} </td>
    </ng-container>

    <!-- Columna Fecha: se muestra siempre -->
    <ng-container matColumnDef="fecha">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%"> FECHA </th>
      <td mat-cell *matCellDef="let element"> {{ element.fecha | date : "dd/MM/yyyy" }} </td>
    </ng-container>

    <!-- Columna Horas Extras: se muestra siempre -->
    <ng-container matColumnDef="horas">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%"> HORAS </th>
      <td mat-cell *matCellDef="let element"> {{ element.horas | number : "1.2-2" }} </td>
    </ng-container>

    <!-- Columna Descripción: se muestra siempre -->
    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef> DESCRIPCIÓN </th>
      <td mat-cell *matCellDef="let element"> {{ element.descripcion }} </td>
    </ng-container>

    <!-- Columna Acciones: se muestra en ambos contextos -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%"> ACCIONES </th>
      <td mat-cell *matCellDef="let element">
        <p-button class="mr-2" icon="pi pi-pencil" (click)="open(content,element.id)" styleClass="p-button-rounded p-button-warning p-button-outlined" ></p-button>
        <p-button class="mr-2" icon="pi pi-trash" (click)="eliminar(content,element.id)" styleClass="p-button-rounded p-button-danger p-button-outlined" ></p-button>
      </td>
    </ng-container>

    <!-- Fila de encabezado y filas de datos -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar pagina de horas extras.">
  </mat-paginator>
</div>

<ng-template style="border: 0px; z-index: 100" #content let-modal>
  <div class="modal-header">
    <h2 class="mb-0 font-semibold" style="font-family: 'Poppins', sans-serif !important;">Actualizar día libre</h2>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form>
      <!-- Fila 1 -->
      <div class="row">
        <!-- Trabajador -->
        <div class="col" hidden>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Trabajador</mat-label>
            <input
              type="text"
              readonly="readonly"
              minlength="3"
              maxlength="100"
              matInput
              name="diasLibres.trabajador"
              [value]="listaHoras.trabajador"
              [(ngModel)]="listaHoras.trabajador"
              disabled hidden
            />
          </mat-form-field>
        </div>

        <!-- Fecha -->
        <div class="col">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Fecha </mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              name="diasLibres.fecha"
              [value]="listaHoras.fecha"
              [(ngModel)]="listaHoras.fecha"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker></mat-datepicker>
            <!-- fecha de entrada y fecha de salida  -->
          </mat-form-field>
        </div>
      </div>

      <!-- Fila 2 -->
      <div class="row">
        <!-- Horas Extras -->
        <div class="col">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Horas Extras</mat-label>
            <input
              type="text"
              matInput
              name="diasLibres.horas"
              [(ngModel)]="listaHoras.horas"
              autonumeric
              [options]="optionsDecimal"
            />
          </mat-form-field>
        </div>

        <!-- Valor Hora -->
        <!-- <div class="col">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Valor Hora</mat-label>
                        <input type="number" minlength="0" maxlength="6" matInput name="diasLibres.valorHora"  [value]="listaHoras.valorHora"[(ngModel)]="listaHoras.valorHora" />
                    </mat-form-field>
                </div> -->
      </div>

      <!-- Fila 3 -->
      <div class="row">
        <!-- Descripción -->
        <div class="col-12">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Descripción</mat-label>
            <input
              type="text"
              minlength="3"
              maxlength="100"
              matInput
              name="diasLibres.descripcion"
              [value]="listaHoras.descripcion"
              [(ngModel)]="listaHoras.descripcion"
            />
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-danger"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">Cancelar</span>
    </button>
    <button
      type="button"
      class="btn btn-outline-success"
      (click)="actualizar_diaLibre()"
    >
      Actualizar
    </button>
  </div>
</ng-template>
